import ApiCore from '../../../services/api/utilities/core'
import apiProvider from '../../../services/api/utilities/provider'

const url = 'companies'
const plural = 'companies'
const single = 'company'

// plural and single may be used for message logic if needed in the ApiCore class.
const apiCompanies = new ApiCore({
  getAll: false,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: false,
  url,
  plural,
  single,
})

apiCompanies.authorize = (compObj) =>
  apiProvider.post('auth/authorize-company', compObj)

apiCompanies.getCustomFields = () => apiProvider.getAll(`${url}/custom-fields`)

apiCompanies.createCustomFields = (data) =>
  apiProvider.post(`${url}/custom-fields`, data)

apiCompanies.deleteField = (fieldName) =>
  apiProvider.remove(`${url}/custom-fields`, fieldName)

/**
 * Updates an organization with the provided data.
 *
 * @param {object} params - The parameters for filtering organization roles.
 * @return {Promise} A promise that resolves with the filtered organization roles data
 */
apiCompanies.getOrgRoles = (id) =>
  apiProvider.getAll(`${url}/${id}/organizations`)

apiCompanies.getDefaultKeys = () => apiProvider.getAll(`${url}/default-keys`)

apiCompanies.getMenuItemCount = () => apiProvider.getSingle(url, `counters`)

apiCompanies.getCompanyProfileConfig = () =>
  apiProvider.getAll(`${url}/profile-config`)

apiCompanies.getDisplay = () => apiProvider.getAll(`${url}/display`)

export default apiCompanies
